// @generated by TypeGen from LogbookModel/Settings/SailGroup.swift - DO NOT EDIT

export enum ISailGroup {
  main = "main",
  foresail = "foresail",
  spinnaker = "spinnaker",
  mizzen = "mizzen",
}

export enum ISailName {
  mainsail = "mainsail",
  genoa = "genoa",
  jib = "jib",
  workingJib = "working_jib",
  stromJib = "strom_jib",
  spinnaker = "spinnaker",
  gennaker = "gennaker",
  code0 = "code0",
  parasailor = "parasailor",
  mizzen = "mizzen",
  mizzenStaysail = "mizzen_staysail",
  trysail = "try",
}

export enum ISailType {
  forestay = "forestay",
  mast = "mast",
  mizzen = "mizzen",
}
